import styled from 'styled-components';

export const WrapSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(6rem, 1fr));
  justify-content: center;
`;

export const BlockWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  width: 6rem;
  height: 6rem;
  margin: ${props => props.theme.spacing.small};
  background-color: ${props =>
    props.isActive ? props.theme.color.primary : props.theme.color.wfWhite};

  svg {
    transform: scale(${props => props.mobileCustomScale});
    path {
      fill: ${props =>
        props.isActive ? props.theme.color.wfWhite : props.theme.color.wfBlack};
    }
  }
`;
